package com.karyadina.di

import com.karyadina.service.OCRService
import com.karyadina.service.TranslationService
import org.koin.core.module.Module

actual fun Module.ocrServiceDefinition() {
    single<OCRService> {
        object : OCRService {
            override suspend fun extractText(imageUri: String): Result<String> {
                return Result.failure(Exception("OCR is not supported on Web"))
            }
        }
    }
}

actual fun Module.translationServiceDefinition() {
    single<TranslationService> {
        object : TranslationService {
            override suspend fun translate(text: String, sourceLang: String, targetLang: String): Result<String> {
                return Result.success(text) // Return original text as fallback
            }

            override suspend fun downloadModelIfNeeded(langCode: String): Result<Boolean> {
                return Result.success(true)
            }
        }
    }
}
